import { render, staticRenderFns } from "./InstructionsDetailedStep3.vue?vue&type=template&id=1fa3e680&"
import script from "./InstructionsDetailedStep3.vue?vue&type=script&lang=js&"
export * from "./InstructionsDetailedStep3.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsDetailedStep3.vue?vue&type=style&index=0&id=1fa3e680&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports